export { default } from './Section'


// WEBPACK FOOTER //
// ./src/components/Section/index.js